// javascript for the cart drawer controls
const openCartBtn = document.querySelector(".Cart-button");
const cartContainer = document.querySelector(".cart-container");
const mainBody = document.querySelector(".main-body");
const cartOverlay = document.querySelector(".blur-overlay");

cartContainer.addEventListener("click", (event) => {
  event.stopPropagation();
  if (event.target.classList.contains("cart-container")) {
    cartContainer.classList.remove("SlideIn");
    cartOverlay.classList.remove("show_blur");
    cartContainer.classList.add("SlideOut");
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }
});
openCartBtn.addEventListener("click", (event) => {
  event.stopPropagation();
  if (event.currentTarget.classList.contains("Cart-button") === true) {
    cartContainer.classList.remove("SlideOut");
    cartContainer.classList.add("SlideIn");
    cartOverlay.classList.add("show_blur");
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }
});

// javascript for the email pop up controls
const emailCloseBtn = document.querySelector(".email-form-close-btn");
const emailContainer = document.querySelector(".email-pop-up-container");
const emailPopUp = document.querySelector(".newsletter-form");
const emailOpenBtn = document.querySelector(".email-open-pop-up");
let session = "true";

const checkSession = () => {
  let email = sessionStorage.getItem("email");
  if (email) {
    session = email;
  } else if (email === null) {
    sessionStorage.setItem("email", true);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    checkSession();
    if (session === "false") {
      // console.log("session dom loaded", session);
      emailContainer.setAttribute("hidden", "true");
      emailContainer.style.display = "none";
      emailContainer.classList.remove("fadeIn");
      emailPopUp.classList.remove("scaleIn");
      emailPopUp.classList.add("scaleOut");
      emailContainer.classList.add("fadeOut");
    } else if (session === "true") {
      // console.log("session dom loaded", session);
      emailContainer.setAttribute("hidden", "false");
      emailContainer.style.display = "flex";
      emailContainer.classList.add("fadeIn");
      emailPopUp.classList.add("scaleIn");
      emailPopUp.classList.remove("scaleOut");
      emailContainer.classList.remove("fadeOut");
    }
  }, 5000);
});

emailOpenBtn.addEventListener("click", (event) => {
  let e = event.currentTarget.classList.contains("email-open-pop-up");
  checkSession();
  // console.log("session", session);
  if (e) {
    if (session === "false") {
      // console.log("session", session);
      emailContainer.setAttribute("hidden", "false");
      emailContainer.style.display = "flex";
      sessionStorage.setItem("email", true);
      emailContainer.classList.add("fadeIn");
      emailPopUp.classList.add("scaleIn");
      emailPopUp.classList.remove("scaleOut");
      emailContainer.classList.remove("fadeOut");
    }
  }
});
emailCloseBtn.addEventListener("click", (event) => {
  let e = event.currentTarget.classList.contains("email-form-close-btn");
  // console.log(e);
  if (e) {
    checkSession();
    if (session === "true") {
      // console.log("session", session);
      emailContainer.setAttribute("hidden", "true");
      emailContainer.style.display = "none";
      sessionStorage.setItem("email", false);
      emailContainer.classList.remove("fadeIn");
      emailPopUp.classList.remove("scaleIn");
      emailPopUp.classList.add("scaleOut");
      emailContainer.classList.add("fadeOut");
    }
  }
});
emailContainer.addEventListener("click", (event) => {
  let e = event.target.classList.contains("email-pop-up-container");
  // console.log(e);
  if (e) {
    checkSession();
    // console.log("session email container", session);
    if (session === "true") {
      // console.log("session", session);
      emailContainer.setAttribute("hidden", "true");
      emailContainer.style.display = "none";
      sessionStorage.setItem("email", false);
      emailContainer.classList.remove("fadeIn");
      emailPopUp.classList.remove("scaleIn");
      emailPopUp.classList.add("scaleOut");
      emailContainer.classList.add("fadeOut");
    }
  }
});
